import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = 'https://sportyreplay.de';
const DEFAULT_DESCRIPTION =
  'Kaufe und verkaufe gebrauchte Sportartikel innerhalb deines Vereins. Regional, nachhaltig und günstig.';

interface SeoProps {
  title: string;
  description?: string;
  /** Pfad inkl. fuehrendem Slash fuer die Canonical-URL, z.B. "/products/29". Default: aktueller Pfad. */
  path?: string;
  /** Bild-URL (absolut oder relativ) fuer og:image. */
  image?: string;
  /** Seite von der Indexierung ausschliessen (z.B. Login, Register). */
  noindex?: boolean;
  type?: string;
  /** JSON-LD strukturierte Daten (Objekt oder Array) fuer Rich Results. */
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

const Seo = ({
  title,
  description = DEFAULT_DESCRIPTION,
  path,
  image,
  noindex = false,
  type = 'website',
  jsonLd,
}: SeoProps) => {
  const pathname = path ?? (typeof window !== 'undefined' ? window.location.pathname : '/');
  const canonical = SITE + pathname;
  const imageUrl = image ? (image.startsWith('http') ? image : SITE + image) : undefined;
  const jsonLdList = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      {imageUrl && <meta property="og:image" content={imageUrl} />}
      {jsonLdList.map((obj, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
      ))}
    </Helmet>
  );
};

export default Seo;
